import React, { useState, useEffect } from 'react';
import { useFormContext, Controller, useWatch } from 'react-hook-form';
import {
  ImageUploadContainer,
  Input,
  Label,
  //SubLabel,
  PreviewImage,
  Button,
  Wrapper,
  //SubLabelWrapper,
  InputColumn,
  PreviewImagesContainer,
  //ErrorMessage,
} from './styled';
import { ReactComponent as UploadIcon } from 'assets/icons/image-icon-black.svg';
import { ReactComponent as CameraIcon } from 'assets/icons/camera-icon-black.svg';
import { ReactComponent as CleanSignIcon } from 'assets/icons/X-white.svg';
import { createErrorToast } from 'utils/createToast';
import { Toast } from 'components/Toast';

const MAX_IMAGES = 3;

const ImageUpload = ({ inputName, isMobile = false, width }) => {
  const [toastList, setToastList] = useState([]);
  const { control, setValue } = useFormContext();
  const watchedFiles = useWatch({ name: inputName, control, defaultValue: [] });
  const [previewUrls, setPreviewUrls] = useState([]);
  const [files, setFiles] = useState([]);
  const [dragActive, setDragActive] = useState(false);
  useEffect(() => {
    if (watchedFiles.length === 0 && (files.length > 0 || previewUrls.length > 0)) {
      setFiles([]);
      setPreviewUrls([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchedFiles]);
  const handleFiles = selectedFiles => {
    if (selectedFiles.length === 0) return;

    // Verifica se ao adicionar os novos arquivos ultrapassaria o limite
    if (files.length + selectedFiles.length > MAX_IMAGES) {
      createErrorToast(setToastList, 'Somente 3 imagens podem ser adicionadas');
      return;
    }

    const newFiles = Array.from(selectedFiles).slice(0, MAX_IMAGES - files.length);

    // Criar URLs para pré-visualização
    const newPreviewUrls = newFiles.map(file => URL.createObjectURL(file));

    setFiles(prev => [...prev, ...newFiles]);
    setPreviewUrls(prev => [...prev, ...newPreviewUrls]);
  };

  const handleFileChange = event => {
    handleFiles(event.target.files);
  };

  const handleDrop = event => {
    event.preventDefault();
    event.stopPropagation();
    setDragActive(false);
    handleFiles(event.dataTransfer.files);
  };

  const handleRemoveImage = index => {
    setPreviewUrls(prevUrls => prevUrls.filter((_, i) => i !== index));
    setFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
  };

  useEffect(() => {
    setValue(inputName, files);
  }, [files, inputName, setValue]);

  useEffect(() => {
    return () => {
      previewUrls.forEach(url => URL.revokeObjectURL(url));
    };
  }, [previewUrls]);

  return (
    <>
      <Controller
        name={inputName}
        control={control}
        defaultValue={[]}
        render={() => (
          <Wrapper width={width}>
            <h5>
              Adicione até <b>{MAX_IMAGES} fotos.</b>
            </h5>

            <div>
              {previewUrls.length < MAX_IMAGES && (
                <InputColumn>
                  {!isMobile && (
                    <ImageUploadContainer
                      borderDashed={true}
                      onDragOver={event => {
                        event.preventDefault();
                        setDragActive(true);
                      }}
                      onDragLeave={() => setDragActive(false)}
                      onDrop={handleDrop}
                      className={`drop-zone ${dragActive ? 'active' : ''}`}
                    >
                      <Input
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleFileChange}
                        id={`fileInput-${inputName}`}
                        aria-label="Carregar imagens"
                      />
                      <Label htmlFor={`fileInput-${inputName}`}>
                        <div>
                          <UploadIcon />
                        </div>
                        Selecione a foto
                      </Label>
                    </ImageUploadContainer>
                  )}
                  {isMobile && (
                    <ImageUploadContainer borderDashed={false}>
                      <Input
                        disabled={!isMobile}
                        id="cameraInput"
                        type="file"
                        accept="image/*"
                        capture="environment"
                        onChange={handleFileChange}
                      />
                      <Label htmlFor="cameraInput">
                        <div>
                          <CameraIcon />
                        </div>
                        Abrir camera
                      </Label>
                    </ImageUploadContainer>
                  )}
                </InputColumn>
              )}
              <PreviewImagesContainer>
                {previewUrls.map((url, index) => (
                  <div key={index}>
                    <PreviewImage src={url} alt={`Preview da Imagem ${index + 1}`} />
                    <Button onClick={() => handleRemoveImage(index)}>
                      <CleanSignIcon />
                    </Button>
                  </div>
                ))}
              </PreviewImagesContainer>
            </div>
          </Wrapper>
        )}
      />
      <Toast toastList={toastList} autoDelete dismissTime={5000} />
    </>
  );
};

export default ImageUpload;
